import React from "react";

export const inputCls =
  "w-full bg-black/50 border border-neutral-700 rounded-xl px-3.5 py-2.5 text-sm text-white outline-none focus:border-[#73bf44] focus:ring-1 focus:ring-[#73bf44] transition-colors placeholder:text-neutral-600";

export function Label({ children, hint }) {
  return (
    <label className="flex items-baseline justify-between text-xs font-medium text-neutral-400 mb-1.5">
      {children}
      {hint && <span className="text-[0.65rem] text-neutral-600 font-normal">{hint}</span>}
    </label>
  );
}
